[
  {
    "workId": "W001",
    "image": "/images/books/W-001-wedding-esea.webp",
    "credit": "Cover: Hong Kong Museum of History / Urban Council; image via esea contemporary Archive.",
    "sourceUrl": "https://archive.eseacontemporary.org/index.php/Detail/library/1616",
    "imageNote": "1986 catalogue cover",
    "width": 515,
    "height": 600
  },
  {
    "workId": "W002",
    "image": "/images/books/W-002-law-uk-cirap.webp",
    "credit": "Cover: Hong Kong Museum of History / Urban Council; image via Asia-Pacific Research Center.",
    "sourceUrl": "https://cirap.com.mo/list-116/574",
    "imageNote": "1990 cover",
    "width": 600,
    "height": 526
  },
  {
    "workId": "W003",
    "image": "/images/books/W-003-children.webp",
    "credit": "Cover: Hong Kong Museum of History / Urban Council; scan supplied by Orchid Press via AbeBooks/ZVAB.",
    "sourceUrl": "https://www.zvab.com/buch-suchen/autor/szeto-naomi-yin-yin/",
    "imageNote": "1990 cover",
    "width": 600,
    "height": 486
  },
  {
    "workId": "W004",
    "image": "/images/books/W-004-dress-carousell.webp",
    "credit": "Cover: Hong Kong Museum of History / Urban Council; image from growingfun on Carousell.",
    "sourceUrl": "https://www.carousell.com.hk/p/%EF%BC%88%E7%8F%BE%E8%B2%A8%E7%B5%95%E7%89%88%EF%BC%89%E7%BE%85%E8%A1%A3%E7%99%BE%E8%BC%89-dress-in-hong-kong-%E9%A6%99%E6%B8%AF%E5%8F%B2%E5%B0%88%E6%9B%B8-1257456891/",
    "imageNote": "1992 cover",
    "width": 447,
    "height": 600
  },
  {
    "workId": "W006",
    "image": "/images/books/W-006-crafts.webp",
    "credit": "Cover: Hong Kong Museum of History / Urban Council; image reproduced by Hong Kong Teaching Resources Centre.",
    "sourceUrl": "https://www.hktrc.com.hk/%E6%AD%B7%E5%B9%B4%E5%B7%A5%E4%BD%9C",
    "imageNote": "Edition associated with this title",
    "width": 459,
    "height": 600
  },
  {
    "workId": "W007",
    "image": "/images/books/W-007-evolution-1997.webp",
    "credit": "Containing-volume cover: Powerhouse Museum / Powerhouse Publishing; image hosted by Open Library.",
    "sourceUrl": "https://openlibrary.org/works/OL19699455W/Evolution_revolution",
    "imageNote": "Containing volume: Evolution & Revolution (1997)",
    "width": 348,
    "height": 475
  },
  {
    "workId": "W008",
    "image": "/images/books/W-008-lei-2005.webp",
    "credit": "Hong Kong Museum of History / Leisure and Cultural Services Department.",
    "sourceUrl": "https://hk.history.museum/en/web/mh/publications/list-of-publications-detail.html",
    "imageNote": "2005 cover",
    "width": 433,
    "height": 600
  },
  {
    "workId": "W009",
    "image": "/images/books/W-009-berg-2011-publisher.webp",
    "credit": "Bloomsbury Publishing / Berg Publishers.",
    "sourceUrl": "https://www.bloomsbury.com/uk/berg-encyclopedia-of-world-dress-and-fashion-vol-6-9781847883957/",
    "imageNote": "Containing volume: East Asia; 2011 hardback cover",
    "width": 424,
    "height": 600
  },
  {
    "workId": "W010",
    "image": "/images/books/W-010-chairs-museum.webp",
    "credit": "Cover: Hong Kong Heritage Museum / Leisure and Cultural Services Department.",
    "sourceUrl": "https://hk.heritage.museum/tc/resources/publications_souvenir/chair.html",
    "imageNote": "2014 cover",
    "width": 442,
    "height": 600
  },
  {
    "workId": "W011",
    "image": "/images/books/W-011-affinity.webp",
    "credit": "Hong Kong Heritage Museum / Leisure and Cultural Services Department; underlying pictured collection objects retain their respective credits.",
    "sourceUrl": "https://hk.heritage.museum/en/resources/publications_souvenir/affinity.html",
    "imageNote": "2017 cover",
    "width": 480,
    "height": 600
  },
  {
    "workId": "W012",
    "image": "/images/books/W-012-day.webp",
    "credit": "Hong Kong Heritage Museum / Leisure and Cultural Services Department; illustration by May Lu (陸梅).",
    "sourceUrl": "https://hk.heritage.museum/en/resources/publications_souvenir/1935.html",
    "imageNote": "2019 cover",
    "width": 415,
    "height": 600
  },
  {
    "workId": "W013",
    "image": "/images/books/W-013-lumei-2023.webp",
    "credit": "Joint Publishing (Hong Kong); artwork by Lu Mei (陸梅); cover image hosted by Sanmin Books.",
    "sourceUrl": "https://www.sanmin.com.tw/product/index/012645479",
    "imageNote": "Containing book: 旗袍時尚情畫 (2023)",
    "width": 255,
    "height": 407
  }
]
